export default __webpack_public_path__ + "static/media/outline-icons.8b892b79.woff";